import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior: (to, from, savedPosition) => {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      redirect: '/jobs',
      name: 'default'
    },
    {
      path: '/jobs',
      name: 'jobs',
      component: () => import('./views/Jobs.vue')
    },
    {
      path: '/public',
      name: 'public',
      component: Home
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('./views/Login.vue')
    },
    {
      path: '/jobs/all',
      name: 'alljobs',
      component: () => import('./views/Jobs.vue')
    },
    {
      path: '/jobs/create',
      name: 'eventscreate',
      component: () => import('./views/EventsForm.vue')
    },
    {
      path: '/jobs/edit/:eventid',
      name: 'eventsedit',
      component: () => import('./views/EventsForm.vue')
    },
    {
      path: '/jobs/:eventid',
      name: 'eventsdets',
      component: () => import('./views/EventsDetails.vue')
    },
    {
      path: '/jobs/:eventid/days',
      name: 'eventsdays',
      component: () => import('./views/DaysMgmt.vue')
    },
    {
      path: '/jobs/:eventid/days/create',
      name: 'dayscreate',
      component: () => import('./views/DaysForm.vue')
    },
    {
      path: '/jobs/:eventid/days/edit/:dayid',
      name: 'daysedit',
      component: () => import('./views/DaysForm.vue')
    },
    {
      path: '/jobs/:eventid/days/:dayid',
      name: 'daysdets',
      component: () => import('./views/DaysDetails.vue')
    },
    {
      path: '/jobs/:eventid/shots',
      name: 'jobsshots',
      component: () => import('./views/ShotsMgmt.vue')
    },
    {
      path: '/jobs/:eventid/shotlist',
      name: 'shotlist',
      component: () => import('./views/Shotlist.vue')
    },
    {
      path: '/jobs/:zohoid/zshotlist',
      name: 'zohoshotlist',
      component: () => import('./views/ZohoShotlist.vue')
    },
    {
      path: '/jobs/:eventid/general',
      name: 'generalshots',
      component: () => import('./views/Shotlist.vue')
    },
    {
      path: '/jobs/:eventid/shots/create',
      name: 'shotscreate',
      component: () => import('./views/ShotsForm.vue')
    },
    {
      path: '/jobs/:eventid/shots/edit/:shotid',
      name: 'shotsedit',
      component: () => import('./views/ShotsForm.vue')
    },
    {
      path: '/jobs/:eventid/shots/:shotid',
      name: 'shotsdets',
      component: () => import('./views/ShotsDetails.vue')
    },
    {
      path: '/users',
      name: 'useradmin',
      component: () => import('./views/UserMgmt.vue')
    },
    {
      path: '/users/create',
      name: 'usercreate',
      component: () => import('./views/UserForm.vue')
    },
    {
      path: '/users/:userid',
      name: 'userdets',
      component: () => import('./views/UserDetails.vue')
    },
    {
      path: '/profile',
      name: 'profile',
      component: () => import('./views/UserDetails.vue')
    },
    {
      path: '/profile/edit',
      name: 'profileedit',
      component: () => import('./views/UserForm.vue')
    },
    {
      path: '/users/edit/:userid',
      name: 'useredit',
      component: () => import('./views/UserForm.vue')
    },
    {
      // to remove
      path: '/cms',
      name: 'cmsadmin',
      component: () => import('./views/CmsMgmt.vue')
    },
    {
      path: '/cms/create',
      name: 'cmscreate',
      component: () => import('./views/CmsForm.vue')
    },
    {
      path: '/cms/edit/:cmsid',
      name: 'cmsedit',
      component: () => import('./views/CmsForm.vue')
    },
    {
      path: '/cms/:cmsid',
      name: 'cmsdets',
      component: () => import('./views/CmsDetails.vue')
    }
  ]
})
